const { mappingError } = require("@/utils/errorAlert/errorMapper");
const { checkNotEmpty } = require("@/utils/popup/common");
const { Error } = require("@/utils/popup/Error");

export const ErrorAlertHandler = (error, head = 0, ctx) => {
    if (!checkNotEmpty(error) || !checkNotEmpty(head) || !checkNotEmpty(ctx))
        return;

    let code = "9999";
    if (error.response?.data?.code) {
        code = error.response.data.code;
    } else if (error.response?.status) {
        code = error.response.status;
    } else if (error.message?.startsWith("timeout")) {
        code = "5008";
    } else if (error.message?.toLowerCase().includes("network")) {
        code = "5010";
    }
    ErrorAlert(code, head, ctx);
};

export const ErrorAlert = (code, head = 0, ctx) => {
    if (!checkNotEmpty(code) || !checkNotEmpty(head) || !checkNotEmpty(ctx))
        return;

    const errorInfo = mappingError(code.toString(), head.toString());

    if(errorInfo?.isGaTagging){
        let event = {
            action: '',
            category: 'DGL_PT_FollowUpDocUpload',
            label: '',
            value: '',
        };
        if(!errorInfo?.isGaDefault){
            event.action = 'Error';
            event.label = errorInfo.title+'/'+errorInfo.detail;
        }

        let userStatus = "null"
        if(ctx?.$store?.state?.userData?.followupStatus?.code){
            userStatus = ctx.$store?.state?.userData?.followupStatus?.code
        }
        let  status = [{
            key: "pt_information",
            value: "Status: " +userStatus
        } ]

        if(errorInfo?.isGaSentErrorCode){
            status = [
                {
                key: "errorCode",
                value: errorInfo.GaErrorCode
            },
            {
                key: "errorDes",
                value: "DisplayType:FullScreen"
            }
            ]
        }

        let dimension = [...status];

        sendGaTagging(event,ctx,dimension);

    }

    Error(
        {
            ...errorInfo,
            callback: () => {
                if(errorInfo?.isGaTagging) {
                    const event = {
                        action: 'Click',
                        category: 'DGL_PT_FollowUpDocUpload',
                        label: 'DGL_PT_FollowUpDocUpload_Confirm',
                        value: '',
                    };

                    sendGaTagging(event,ctx);
                }
                switch (errorInfo.callbackAction) {
                    case "goToProductShelves":
                        try {
                            ctx.$callback.openLFMProductionShelf();
                        } catch (err) {
                            console.error(err);
                        }
                        break;
                    case "goToUpload":
                        try {
                            ctx.$callback.openLfmStatusPage();
                        } catch (err) {
                            console.error(err);
                        }
                        break;
                    default:
                        break;
                }
            },
        },
        ctx.$swal
    );
};

const sendGaTagging = (event,ctx,firebaseParam = undefined) => {
    if("1115" === ctx?.userData?.marketCode && "7002" === ctx?.userData?.productType){
        const product = {
            key: "product_type",
            value: "DL_SMARTMONEY"
        }
        let dimension = [product];
        if(firebaseParam ){
            dimension = [...dimension,...firebaseParam]
        }
        try {
            ctx.$callback.gaTagging(event, dimension);
        } catch (err) {
            console.error("GA Tagging error", err);
        }
    }

}
